import React from 'react';
import PropTypes from 'prop-types';
import {Field, reduxForm} from 'redux-form';

const validate = (values) => {
    const errors = {};

    if (!values.login) {
        errors.login = 'Vaaditaan';
    }

    if (!values.password) {
        errors.password = 'Vaaditaan';
    }

    return errors;
};

const renderField = ({input, label, placeholder, type, value, meta: {touched, error}}) => (
  <div className='form-group'>
    <label className='upper-label'>{label}</label>
    <input {...input} type={type} placeholder={placeholder} value={value}
      className={touched && error && 'form-control is-invalid'
           || touched && 'form-control is-valid' || 'form-control'}/>
  </div>
);

const LoginForm = props => {
  const {
    navigateToPasswordResetPage,
    handleSubmit,
    submitting,
    submitFailed,
    translations
  } = props;

  return (
    <div className='wrapper'>
      <form className='form-signin' onSubmit={handleSubmit}>
        <h2 className='form-signin-header'>
          Helsingin Sataman luvat
        </h2>
        {submitFailed &&
          <div className='alert alert-danger'>
            <span className='fa fa-exclamation-triangle' />&nbsp;
             Virheellinen käyttäjätunnus ja/tai salasana.
          </div>
        }
        <Field
          name='login'
          type='text'
          label={translations['user.Käyttäjätunnus']}
          component={renderField}
          placeholder={translations['user.Käyttäjätunnus']}
          />
        <Field
          name='password'
          type='password'
          label={translations['user.Salasana']}
          component={renderField}
          placeholder={translations['user.Salasana']}
        />
        <button
          className='btn btn-primary btn-lg col-lg-12'
          type='submit'
          disabled={submitting}
        >
          <span className='btn-text'>
            {translations['user.Kirjaudu sisään']}
          </span>
        </button>
        <div className='password-forgotten'>
          <a onClick={navigateToPasswordResetPage}>
            Salasana unohtunut?
          </a>
        </div>
      </form>
    </div>
  )
};

LoginForm.propTypes = {
    handleSubmit: PropTypes.func,
    fields: PropTypes.object,
    translations: PropTypes.object
};

export default reduxForm({
    form: 'loginForm',
    validate
})(LoginForm);



// WEBPACK FOOTER //
// ./src/components/LoginForm.js